import React from "react";

export function FormFieldRow({ children, className = "" }) {
  return <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 ${className}`}>{children}</div>;
}

export default function FormField({
  id,
  label,
  required,
  error,
  touched,
  children,
  className = "",
}) {
  const errorId = error ? `${id}-error` : undefined;
  const showError = touched && error;

  return (
    <div className={`flex flex-col gap-1 min-w-0 ${className}`}>
      <label htmlFor={id} className="block text-sm font-medium text-slate-700">
        {label}
        {required ? <span className="text-rose-500"> *</span> : null}
      </label>
      {children}
      {showError ? (
        <span id={errorId} className="text-xs text-rose-600" role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}
